function _refreshDocumentTitle(newVal) {
    document.title = (newVal || '');
}

function makeDocumentTitle(page, subpage) {
    if (page && subpage) {
        return `Alumni CMS — ${page}: ${subpage}`;
    }
    if (page) {
        return `Alumni CMS — ${page}`;
    }

    return 'Alumni CMS';
}

function updateTitle() {
    try {
        _refreshDocumentTitle(window.router.currentRoute.matched.last().instances.default.documentTitle);
    } catch (error) {
        _refreshDocumentTitle(makeDocumentTitle());
    }
}

export default {
    methods: {
        makeDocumentTitle,
        refreshDocumentTitle(newVal) {
            if (this.$router.currentRoute.matched.last().instances.default === this) {
                _refreshDocumentTitle(newVal);
            }
        }
    },
    watch: {
        documentTitle(newVal) {
            this.refreshDocumentTitle(newVal);
        }
    },
    mounted() {
        this.refreshDocumentTitle(this.documentTitle);
    }
};
export { updateTitle };
